<template>
  <div class="stickers-upsell-sizes">
    <button
      v-for="size in sizes"
      :key="size.value"
      :class="{
        'stickers-upsell-sizes__item': true,
        'stickers-upsell-sizes__item--selected': value && value.value === size.value
      }"
      @click.prevent="handleSizeChange(size)"
    >
      {{ size.label }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  value: [Object, null],
  sizes: Array
});

const emit = defineEmits(["change"]);

const handleSizeChange = size => {
  emit("change", size);
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/settings";

.stickers-upsell-sizes {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;

  &__item {
    appearance: none;
    border-radius: 4px;
    border: 1px solid $gray-label;
    background: $white;
    padding: 10px;
    color: $text-black;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.42;
    display: flex;
    justify-content: center;
    align-items: center;

    &--selected {
      border: 2px solid $bright-pink;
      padding: 9px 11px;
    }

    @include with-tablet {
      flex-wrap: wrap;
      min-width: 80px;
    }
  }
}
</style>
